<template>
  <div>
    <a-list itemLayout="horizontal" :dataSource="data">
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta>
          <a slot="title">{{ item.title }}</a>
          <span slot="description">
            <span class="security-list-description">{{
              item.description
            }}</span>
            <span v-if="item.value">:</span>
            <span class="security-list-value">{{ item.value }}</span>
          </span>
        </a-list-item-meta>
        <template v-if="item.actions">
          <a slot="actions" @click="item.actions.callback">{{
            item.actions.title
          }}</a>
        </template>
      </a-list-item>
    </a-list>
    <a-modal
      v-model="modal.visible"
      title="修改密码"
      @ok="handleOk"
      @cancel="cancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="原登录密码" prop="password">
          <a-input
            v-model="formData.password"
            type="password"
            :maxLength="20"
          />
        </a-form-model-item>
        <a-form-model-item label="新登录密码" prop="newPassword">
          <a-input
            v-model="formData.newPassword"
            type="password"
            :maxLength="20"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "AdminSecurity",
  data() {
    return {
      userInfo: this.$store.getters.userInfo,
      data: [
        {
          title: "账户密码",
          description: "",
          value: "",
          actions: {
            title: "修改",
            callback: () => {
              this.modal.visible = true;
            }
          }
        }
      ],
      modal: {
        visible: false
      },
      //form
      formData: {
        password: "",
        newPassword: "",
        type: "modify"
      },
      //form rules
      rules: {
        password: [
          {
            required: true,
            message: "请输入原登录密码",
            trigger: "change"
          }
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新登录密码",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    cancel() {
      this.modal.visible = false;
      this.formData = { type: "modify" };
      this.$refs.ruleForm.resetFields();
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          param.userNo = this.userInfo.userNo;
          this.$http.systemBksApi.modifyPassword(param).then(res => {
            if (res.result == 0) {
              this.cancel();
              this.$message.success(res.msg);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped></style>
